/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2023, Zumper
 * @description getPrimaryFacetFromFiltersPath
 */

import { MAX_FILTER_PRICE, MIN_FILTER_PRICE, getCanonicalPathFromFilters } from '@zcode-ui/filters'
import type { Filters } from '@zcode/state-type'

export const getPrimaryFacetFromFiltersPath = (canonicalPathFilters: Filters) => {
  const filtersObj = { ...canonicalPathFilters }
  // define special rel canonical conditions
  if (filtersObj.cats || filtersObj.dogs) {
    filtersObj.cats = true
    filtersObj.dogs = true
  }

  // remove price filters
  filtersObj.customMaxPrice = false
  filtersObj.maxPrice = MAX_FILTER_PRICE
  filtersObj.minPrice = MIN_FILTER_PRICE

  // find the most important facet (will first eg. /no-fee/furnished -> /no-fee)
  const derivedFiltersPath = getCanonicalPathFromFilters(filtersObj)
  return derivedFiltersPath.replace(/^([/][^/]*).*/, '$1')
}
